import CalendarFolder from 'owa-service/lib/contract/CalendarFolder';
import { AllCalendarEntry } from '../schema/AllCalendarEntry';
import { OnlineMeetingProviderType } from 'mini-calendar-event-types';

export const getDefaultOnlineMeetingProvidersForCalendarEntry = (
    calendarEntry: AllCalendarEntry,
    calendarFolder: CalendarFolder
) =>
    (calendarEntry?.DefaultOnlineMeetingProvider ||
        calendarFolder?.DefaultOnlineMeetingProvider) as OnlineMeetingProviderType;
